// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconEusde } from "../../../icons/mono/build/icon-eusde.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const EusdeIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconEusde.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  EusdeIcon.displayName = 'EusdeIcon';
}

export default EusdeIcon;